/**
 * Name of the flag which toggles maintenance mode feature.
 *
 * @type {string}
 */
export const FEATURE_FLAG_MAINTENANCE_MODE = `maintenance_mode`;
export const FEATURE_FLAG_TENANT_SELF_CHECK = `tenant_self_check`;
